// profileApi.ts — Mi Perfil del operador (Karla/staff) = módulo PERFIL compartido de lealify-base.
// Va a /api/me/* (núcleo, NO /api/letsmove). Sesión por cookie same-origin.

export interface MyProfile {
  id: number;
  name: string;
  email: string | null;
  phone: string | null;
  avatar_url: string | null;
  birthdate: string | null;
  role: string;
}

async function call(path: string, opts: RequestInit = {}) {
  const res = await fetch('/api' + path, {
    credentials: 'include',
    ...opts,
    headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data && data.error) || `Error ${res.status}`);
  return data;
}

export const getMyProfile = (): Promise<{ actor: string; profile: MyProfile }> => call('/me/profile');

export const updateMyProfile = (patch: Partial<MyProfile>): Promise<{ actor: string; profile: MyProfile }> =>
  call('/me/profile', { method: 'PUT', body: JSON.stringify(patch) });

export const uploadMyAvatar = (image: string): Promise<{ avatar_url: string }> =>
  call('/me/avatar', { method: 'POST', body: JSON.stringify({ image }) });
